var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"fish back-top",on:{"click":function($event){return _vm.clickHandler($event)}}},[_c('i',{staticClass:"fa fa-arrow-up"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }